export const structSpec = [
  {
    "label": "Anak",
    "children": [
      { "label": "Konsultan Alergi Imunologi" },
      { "label": "Konsultan Emergensi dan Rawat Inap Intensif Anak" },
      { "label": "Konsultan Endokrinologi Anak" },
      { "label": "Konsultan Gastro - Hepatologi" },
      { "label": "Konsultan Hemato Onkologi" },
      { "label": "Konsultan Neonatologi" },
      { "label": "Konsultan Nutrisi dan Penyakit Metabolik Anak" },
      { "label": "Konsultan Paru Anak" },
      { "label": "Konsultan Perinatologi" },
      { "label": "Konsultan Saraf Anak" }
    ]
  },
  { "label": "Andrologi" },
  { "label": "Anestesi" },
  { "label": "Bedah",
    "children": [
        { "label": "Bedah (Konsultan Digestif/Pencernaan)" },
        { "label": "Bedah Anak" },
        { "label": "Bedah Konsultan Vaskuler" },
        { "label": "Bedah Onkologi" },
        { "label": "Bedah Plastik Rekonstruksi Estetik" },
        { "label": "Bedah Saraf" },
        { "label": "Bedah Toraks Kardiovaskuler" },
        { "label": "Bedah Umum" },
    ]
   },
  {
    "label": "Dental",
    "children": [
      { "label": "Bedah Mulut" },
      { "label": "Gigi Umum" },
      { "label": "Kedokteran Gigi Anak" },
      { "label": "Konservasi Gigi" },
      { "label": "Orthodonsia" },
      { "label": "Periodonsia (Jaringan Gusi dan Penyangga Gigi)" },
      { "label": "Prostodonsia (Restorasi Rongga Mulut)" }
    ]
  },
  { "label": "Dermatovenerologi" },
  { "label": "Gizi Klinik" },
  { "label": "Jantung dan Pembuluh Darah" },
  { "label": "Kedokteran Fisik dan Rehabilitasi" },
  { "label": "Kedokteran Olahraga" },
  { "label": "Konselor Laktasi" },
  { "label": "Kulit dan Kelamin" },
  {
    "label": "Lab & Radiologi",
    "children": [
      { "label": "Patologi Anatomi" },
      { "label": "Patologi Klinik" },
      { "label": "Radiologi" }
    ]
  },
  { "label": "Mata" },
  {
    "label": "Obgyn",
    "children": [
      { "label": "Fetomaternal" },
      { "label": "Infertilitas" },
      { "label": "Onkologi" }
    ]
  },
  {
    "label": "Orthopaedi dan Traumatologi",
    "children": [
      { "label": "Bedah Tangan & Bedah Mikro" },
      { "label": "Panggul dan Lutut" },
      { "label": "Sports atau Cedera Olahraga" },
      { "label": "Trauma" },
      { "label": "Tulang Belakang" },
      { "label": "Umum dan Anak" }
    ]
  },
  { "label": "Paru" },
  {
    "label": "Penyakit Dalam",
    "children": [
      { "label": "Endokrin" },
      { "label": "Gastro" },
      { "label": "Hemato Onkologi" },
      { "label": "Konsultan Ginjal - Hipertensi" }
    ]
  },
  { "label": "Psikiatri" },
  {
    "label": "Psikologi",
    "children": [
      { "label": "Klinik Psikologi" },
      { "label": "Klinis Anak" },
      { "label": "Pernikahan & Klinis Dewasa" },
      { "label": "Psikolog Olahraga, Klinis Anak & Remaja" },
      { "label": "Trauma Healing & Klinis Dewasa" }
    ]
  },
  { "label": "Saraf" },
  { "label": "Saraf Anak-anak" },
  { "label": "Telinga Hidung Tenggorok -Bedah Kepala dan Leher" },
  { "label": "Umum" },
  { "label": "Urologi" }
]
